"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const remoting_1 = __importDefault(require("./remoting"));
const pairing_1 = __importDefault(require("./pairing"));
const remotingStateSelector = state => get_1.default(state, 'app.remoting');
exports.default = {
    remoting: remoting_1.default,
    pairing: pairing_1.default,
    remotingStateSelector
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/selectors/index.js
// module id = 609
// module chunks = 0